import { Beneficiary, BeneficiaryApiResponse } from '@/types/beneficiary';
import { BeneficiaryType } from '@/types/customer';

export const toBeneficiary = (apiResponse: BeneficiaryApiResponse): Beneficiary => {
  const name =
    apiResponse.type === BeneficiaryType.business
      ? (apiResponse.business?.name ?? '')
      : `${apiResponse.person?.firstName ?? ''} ${apiResponse.person?.lastName ?? ''}`.trim();

  return {
    id: apiResponse.id,
    name: name,
    type: apiResponse.type,
    createdDate: apiResponse.createdDate,
  };
};
